import { render, staticRenderFns } from "./add-origin-destination.vue?vue&type=template&id=62b237ee&scoped=true"
import script from "./add-origin-destination.vue?vue&type=script&lang=js"
export * from "./add-origin-destination.vue?vue&type=script&lang=js"
import style0 from "./add-origin-destination.vue?vue&type=style&index=0&id=62b237ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b237ee",
  null
  
)

export default component.exports